import { SparklesIcon } from "@heroicons/react/24/outline";

import { FundingMethod } from "../../../../utils/fundingMethods";

interface ComingSoonPanelProps {
  method: FundingMethod;
}

export default function ComingSoonPanel({ method }: ComingSoonPanelProps) {
  const Icon = method.icon;

  return (
    <div className="flex flex-col items-center py-8 text-center">
      <span className="relative flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-50 text-primary">
        <Icon className="h-8 w-8" />
        <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-secondary text-primary">
          <SparklesIcon className="h-3.5 w-3.5" />
        </span>
      </span>

      <h3 className="mt-5 text-lg font-semibold text-gray-900">
        {method.label} is coming soon
      </h3>
      <p className="mt-2 max-w-xs text-sm text-gray-500">
        We&apos;re putting the finishing touches on {method.label.toLowerCase()}{" "}
        funding. In the meantime, you can top up instantly with a bank transfer.
      </p>

      <span className="mt-6 rounded-full bg-gray-100 px-4 py-1.5 text-xs font-medium text-gray-500">
        Launching soon
      </span>
    </div>
  );
}
